<template>
    <div class="bg-login-image min-h-screen flex flex-col items-center justify-center bg-cover bg-center relative">
      <div class="absolute inset-0 bg-black/50"></div>
  
      <div
        class="relative flex flex-col w-full max-w-lg lg:max-w-md xl:max-w-xl px-6 py-8 sm:px-12 md:px-16 m-auto bg-white/80 rounded-lg shadow-lg dark:bg-gray-800">
        <div class="flex justify-center items-center">
          <img src="../../../assets/logo.png" class="w-28" />
        </div>
  
        <svg class="mx-auto w-24 h-24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_iconCarrier">
            <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke="#00cc07" stroke-width="1" stroke-linecap="round"
              stroke-linejoin="round"></path>
            <path
              d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
              stroke="#00cc07" stroke-width="1.5" stroke-linecap="round"></path>
          </g>
        </svg>
  
        <!-- NUEVO MENSAJE -->
        <h2 class="text-3xl text-center text-red-700 font-semibold mb-4">
          Este tratamiento requiere entrevista telefónica
        </h2>
  
        <p class="text-center text-lg text-gray-800 mb-6">
          Nos comunicaremos  a la mayor brevedad, o puedes llamarnos directamente:
        </p>
  
        <div class="flex justify-center mb-6">
          <a
            href="tel:7874159799"
            class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded shadow transition-all duration-200"
          >
            📞 Llamar al 787-415-9799
          </a>
        </div>
  
        <!-- BOTÓN IR AL INICIO -->
        <div class="flex justify-center">
          <router-link to="/">
            <button type="button"
              class="text-white bg-green-700 hover:bg-green-800 focus:ring-4 my-6 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-3 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
              Ir al inicio
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </template>
  
  <style scoped>
  .bg-login-image {
    background-image: url('/public/fondologin.jpg');
    background-size: cover;
    background-position: center;
  }
  
  button:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  
  button i {
    font-size: 1.25rem;
  }
  </style>
  